<template>
  <div class="container">
      <form>
<label class="listOneRow"><p class="_title">お名前 (ご担当者名)</p>
<div class="_content"><input type=text name="name" v-model="fieldItems.name" placeholder="お名前を入力してください">
<p class="inputError" v-if="!$v.fieldItems.name.required">必須です</p></div>
</label>

<label class="listOneRow"><p class="_title">御社名</p><p class="_content"><input type=text name="company" v-model="fieldItems.company" placeholder="御社名をご記入ください"></p></label>

<label class="listOneRow"><p class="_title">部署名</p><p class="_content"><input type=text name="department" v-model="fieldItems.department" placeholder="所属部署をご記入ください"></p></label>

<label class="listOneRow">
<p class="_title">メールアドレス</p> 
<div class="_content"><input type=text name="email" v-model="fieldItems.mail" placeholder="ご連絡がつくメールアドレスをご記入ください">
<p class="inputError" v-if="!$v.fieldItems.mail.email">メールアドレスを記入してください</p>
<p class="inputError" v-if="!$v.fieldItems.mail.required">必須です</p>
</div>
</label>

<label class="listOneRow">
<p class="_title">電話番号 (任意)</p>
<div class="_content"><input type=text name="tel" v-model="fieldItems.telephone" placeholder="0311112222  - (ハイフン)なしで入力ください">
<p class="inputError" v-if="!$v.fieldItems.telephone.integer">整数の半角数字以外は入力できません。</p>
</div>
</label>

<div class="listOneRow">
  <label for="page" p class="_title">お問い合わせの項目<span class="brPc"></span> (複数可)</label>
  <div class="_content listMultiRow">
    <label class="">
      <input type="checkbox" name="inqueryItem" value="見積り依頼" v-model="fieldItems.inquirys">見積り依頼
    </label>
    <label class="">
      <input type="checkbox" name="inqueryItem" value="採用について" v-model="fieldItems.inquirys">採用について
    </label>
    <label class="">
      <input type="checkbox" name="inqueryItem" value="その他" v-model="fieldItems.inquirys">その他
    </label>
  </div>
</div>

<label class="listOneRow lastRow">
  <p class="_title">お問い合わせの内容</p>
  <div class="_content">
    <div class="inputError" v-if="!$v.fieldItems.freeText.required">必須です</div>
    <div class="inputError" v-if="!$v.fieldItems.freeText.maxLength">2000文字まで入力可能です</div>
    <p class=""><textarea name="comment" rows=6 wrap=soft v-model="fieldItems.freeText" placeholder="なるべく詳しくお書きください（2000字以内）"></textarea></p>
  </div>
</label>

<input type="button" value="確認する" class="nextToPhase buttonAction" @click="toConfirm">
<input type="reset" value="reset" class="inputInitial buttonAction" @click="resetForm">
      </form>
  </div>
</template>

<script>
import { required, email, integer, maxLength } from 'vuelidate/lib/validators'
export default {
  name:'phaseInput',
  props: {
    fields: {
      name:{
        type:String,
        required: true,
      }, 
      company:{
        type:String
      }, 
      department:{
        type:String
      },
      mail:{
        type:String,
        required: true,
      }, 
      telephone:{
        type:String
      }, 
      inquirys:{
        type:Object,
        required: true,
      }, 
      freeText:{
        type:String,
        required: true,
      },
    }
  },
  data: function(){
    return {
      isName:true,
      isMail:true,
      isFreeText:true,
      fieldItems:this.fields
    }
  },
  validations:{
    fieldItems: {
      name:{ required },
      mail:{ required, email },
			telephone:{ integer },
      freeText:{ required, maxLength: maxLength(2000) },
    }
  },
  methods:{
    resetForm() {
document.getElementById("ContactTop").scrollIntoView({behavior:"smooth"})
    },
    toInput() {
//      this.$emit('changePhase', 'form-input')
    },
    toConfirm() {
      if (this.$v.$invalid) {
        console.log('バリデーションエラー')
document.getElementById("ContactTop").scrollIntoView({behavior:"smooth"})

      } else {
        this.$emit('changePhase', 'form-confirm')
      }
    },
    toThanks() {
//      this.$emit('changePhase', 'form-thanks')
    },
  }
}
</script>

<style>
</style>
